Auth = require 'db/auth'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
Util = require 'lib/util'
_ = require 'underscore'

module.exports =
  getSearchUrl: (query) ->
    "/search?q=#{ encodeURIComponent(query) }"

  getOrganizationName: (org) ->
    if _.isString(org) then org else org.get('name')

  getOrganizationUrl: (org) ->
    "/#{ @getOrganizationName(org) }"

  getEnterpriseAdminDashboardUrl: (enterpriseOrName, tab) ->
    name = if _.isString(enterpriseOrName)
        enterpriseOrName
      else
        enterpriseOrName.get('name')
    if tab?
      "/e/#{ name }/admin/#{ tab }"
    else
      "/e/#{ name }/admin"

  _orgUrl: (org, path, options = {}) ->
    query =
      if options.returnUrl
        query = '?returnUrl=' + encodeURIComponent(options.returnUrl)
      else
        ""

    "#{ @getOrganizationUrl(org) }#{ path }#{ query }"

  getOrganizationMemberCardsUrl: (org, username) -> @getMemberCardsUrl(username, @getOrganizationName(org))
  getOrganizationAccountUrl: (org) -> @_orgUrl(org, '/account')
  getOrganizationBillingUrl: (org, options) -> @_orgUrl(org, '/billing', options)
  getOrganizationExportUrl: (org) -> @_orgUrl(org, '/export')
  getOrganizationMembersUrl: (org) -> @_orgUrl(org, '/members')
  getOrganizationGuestUrl: (org) -> @_orgUrl(org, '/members/guests')

  getBoardUrl: (idBoard, section, extra = []) ->
    if idBoard?.id?
      idBoard = idBoard.id

    board = ModelCache.get('Board', idBoard)

    if (url = board?.get('url'))?
      baseUrl = Util.relativeUrl(url)

    else
      name = board?.get('name')

      baseUrl =
        if name
          "/board/#{Util.makeSlug(name)}/#{idBoard}"
        else
          "/board/#{idBoard}"

    if section
      baseUrl += "/#{ section }"

    for part in extra
      baseUrl += "/#{ part }"

    baseUrl

  getBoardShortUrl: (idBoard, section) ->
    if idBoard?.id?
      idBoard = idBoard.id

    board = ModelCache.get('Board', idBoard)

    if (shortUrl = board?.get('shortUrl'))?
      baseUrl = Util.relativeUrl(shortUrl)

    else
      shortLink = board?.get('shortLink')

      baseUrl = "/b/#{ shortLink }"

    if section
      baseUrl += "/#{ section }"

    baseUrl

  getBoardPowerUpsUrl: (board) ->
    @getBoardUrl(board) + '/power-ups'

  getUpgradeUrl: (board) ->
    if (org = board.getOrganization())?
      @getOrganizationBillingUrl(org)
    else
      '/business-class'

  getBoardPowerUpsUpgradeUrl: (board) ->
    if (org = board.getOrganization())?
      @getOrganizationBillingUrl(org, {
        returnUrl: @getBoardPowerUpsUrl(board)
      })
    else
      '/business-class'


  getMemberBoardProfileUrl: (username, idBoard) -> [@getBoardUrl(idBoard), 'member', username].join('/')
  getMemberProfileUrl: (username = Auth.myUsername()) -> "/#{username}"
  getMemberNotificationsUrl: (username = Auth.myUsername()) -> "/#{username}/notifications"
  getMemberBoardsUrl: (username = Auth.myUsername(), orgname, boardsTab, cardsTabName) ->
    if orgname
      return @getMemberOrgUrl(orgname, boardsTab, cardsTabName)
    else if boardsTab
      return "/#{username}/boards"
    else
      return '/'
  getMemberOrgUrl: (orgname, boardsTab, cardsTabName) ->
    if cardsTabName
      return "/#{orgname}/cards/#{cardsTabName}"
    if boardsTab
      return "/#{orgname}/home"
    else
      return "/#{orgname}/highlights"

  getMemberCardsUrl: (username = Auth.myUsername(), orgname) ->
    if orgname
      "/#{username}/cards/#{orgname}"
    else
      "/#{username}/cards"
  getMemberAccountUrl: (username = Auth.myUsername()) -> "/#{username}/account"
  getMemberBillingUrl: (username = Auth.myUsername()) -> "/#{username}/billing"

  getCardUrl: (card, highlight, replyToComment) ->
    baseUrl =
      if (url = card.get('url'))?
        Util.relativeUrl(url)
      else
        card_name = card.get('name')
        @getCardUrlWithoutModels(card.get('idBoard'), card.get('idShort') ? card.id, card_name)

    if replyToComment
      [baseUrl, "replyToComment=#{replyToComment}"].join('?')
    else if highlight
      [baseUrl, highlight].join('#')
    else
      baseUrl

  getCardUrlWithoutModels: (idBoard, idCard, card_name) ->
    if !idCard?
      null
    else if Util.isShortId(idCard)
      "/card/#{Util.makeSlug(card_name)}/#{idBoard}/#{idCard}"
    else
      "/card/board/#{Util.makeSlug(card_name)}/#{idBoard}/#{idCard}"

  getBoardInvitationLinkUrl: (board, secret) ->
    "/invite/b/#{ board.get('shortLink') }/#{ secret }/#{ Util.makeSlug(board.get('name')) }"

  getOrganizationInvitationLinkUrl: (org, secret) ->
    "/invite/#{ org.get('name') }/#{ secret }"

  getActionUrl: (action) ->
    prefix =
      if action.isCommentLike()
        "comment"
      else
        "action"

    highlight = [prefix, action.id].join('-')

    @getCardUrl(action.getCard(), highlight)



// WEBPACK FOOTER //
// ./app/scripts/controller/urls.coffee